import { beforeOrgMemberGuard } from "@/features/auth/guards";
import {
  createFileRoute,
  Outlet,
  Link,
  Navigate,
} from "@tanstack/react-router";
import { useOrg } from "@/contexts/org-context";
import { Loader2, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/app/settings/organisation")({
  beforeLoad: beforeOrgMemberGuard,
  component: OrgSettingsLayout,
});

function OrgSettingsLayout() {
  const { activeOrgId, loading, activeRole } = useOrg();

  if (loading) {
    return (
      <div className="flex h-[50vh] w-full items-center justify-center">
        <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (activeRole === "advisor") {
    return <Navigate to="/app/settings/user/profile" />;
  }

  if (!activeOrgId) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center p-8 text-center">
        <div className="bg-destructive/10 text-destructive mb-4 flex h-12 w-12 items-center justify-center rounded-full">
          <AlertTriangle className="h-6 w-6" />
        </div>
        <h2 className="mb-2 text-lg font-semibold">Something went wrong</h2>
        <p className="text-muted-foreground mb-6 max-w-sm text-sm">
          We couldn't load your organisation. Please try again later. If the
          issue persists, contact support.
        </p>
        <Button asChild variant="outline" size="sm">
          <Link to="/app/settings/user/support">Open a support request</Link>
        </Button>
      </div>
    );
  }

  return <Outlet />;
}
